export default function CArithmeticOperators() {
  return <h2>C Arithmetic Operators</h2>;
}
